import { render, staticRenderFns } from "./prelabelModelConf.vue?vue&type=template&id=767c2958&scoped=true"
import script from "./prelabelModelConf.vue?vue&type=script&lang=js"
export * from "./prelabelModelConf.vue?vue&type=script&lang=js"
import style0 from "./prelabelModelConf.vue?vue&type=style&index=0&id=767c2958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767c2958",
  null
  
)

export default component.exports